import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';

const ThemeModeContext = createContext(null);

const STORAGE_KEY = 'ui.colorMode';

const createAppTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: { main: '#0E4D94' },
      secondary: { main: '#f9a825' },
      background: mode === 'dark' ? { default: '#0b0f19', paper: '#0f1422' } : { default: 'oklch(96.7% .001 286.375)', paper: '#ffffff' },
    },
    shape: { borderRadius: 10 },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Arial, sans-serif',
      fontWeightRegular: 400,
      fontWeightBold: 600,
    },
  });

export const ThemeModeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => localStorage.getItem(STORAGE_KEY) || 'light');

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, mode);
  }, [mode]);

  const value = useMemo(
    () => ({
      mode,
      toggleMode: () => setMode((m) => (m === 'light' ? 'dark' : 'light')),
    }),
    [mode]
  );

  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeModeContext.Provider value={value}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
};

export const useColorMode = () => {
  const ctx = useContext(ThemeModeContext);
  if (!ctx) throw new Error('useColorMode must be used within ThemeModeProvider');
  return ctx;
};


